import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { QuoteListView } from './quote-list.view';
import { QuoteListDataService } from './quote-list.data';
import { FormatService } from 'src/core/services/format.service';
import { ContextService } from 'src/core/services/context.service';

interface Props extends ControllerProps<{}> {
	clientId?: number;
}

@observer
export class QuoteListController extends React.Component<Props, {}> {
	@resolve
	dialogService: DialogService;

	@resolve
	contextService: ContextService;

	@resolve
	formatService: FormatService;

	@resolve
	toast: ToastNotifications;

	@observable
	dataService: QuoteListDataService;

	constructor(props: Readonly<Props>) {
		super(props);
	}

	componentDidMount() {
		this.initialize(this.props.clientId);
	}

	componentWillReceiveProps(nextProps: Readonly<Props>) {
		if (nextProps.clientId !== this.props.clientId) {
			this.initialize(nextProps.clientId);
		}
	}

	private initialize(clientId?: number): void {
		this.props.setBusy(true);
		this.loadData(clientId)
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	private async loadData(clientId?: number): Promise<void> {
		this.dataService = QuoteListDataService.make(this.contextService, this.formatService);

		this.dataService.addSorting('id', 'desc', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		if (this.props.clientId) {
			this.dataService.addFilter('clientId', 'eq', this.props.clientId);
		}

		await this.dataService.load(query => query);
	}

	handleItemDoubleClick = (item: QuoteSummary): void => {
		this.props.history.push(`/bookings/quotes/${item == null ? 'new' : item.id}`);
	}

	render() {
		if (this.dataService == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<div className="panel">
					<QuoteListView
						model={this.dataService}
						setBusy={this.props.setBusy}
						onItemDoubleClicked={this.handleItemDoubleClick}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quotes/list/quote-list.controller.tsx